import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CONTACT } from "@/content/site";
import { Footer } from "@/components/Footer";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl text-[#252525] mb-4">{title}</h2>
    <div className="text-base text-[#4A4A4A] leading-relaxed space-y-4">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <>
      <main className="pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 text-sm text-[#252525] border-b border-[#B69A58] pb-1 hover:text-[#B69A58] transition-colors duration-300"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.5} />
            Zpět na hlavní stránku
          </Link>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight text-[#252525] mt-10">
            Ochrana osobních údajů
          </h1>

          <Section title="Kdo údaje zpracovává">
            <p>
              Správcem osobních údajů je {CONTACT.name}, IČO: {CONTACT.ico}, se sídlem {CONTACT.sidlo},
              provozovatel webu pekardaniel.cz.
            </p>
            <p>
              S dotazy ke zpracování údajů se na mě můžete obrátit na{" "}
              <a href={`mailto:${CONTACT.email}`} className="underline underline-offset-2 hover:text-[#B69A58] transition-colors duration-300">
                {CONTACT.email}
              </a>{" "}
              nebo telefonicky na {CONTACT.phone}.
            </p>
          </Section>

          <Section title="Jaké údaje zpracovávám a proč">
            <p>
              Pokud mi napíšete přes kontaktní formulář, zpracovávám vámi uvedené údaje —
              jméno, e-mail, případně telefon a obsah zprávy — výhradně za účelem vyřízení
              vašeho dotazu a domluvení konzultace.
            </p>
            <p>
              Pokud si nastavíte připomenutí kontroly pojištění, uchovávám vaše jméno
              a e-mail po dobu jednoho roku výhradně za účelem zaslání této jedné připomínky.
            </p>
            <p>
              Pokud si navrhnete termín konzultace, zpracuji uvedené údaje (jméno, e-mail,
              telefon a zvolený termín) k domluvení a potvrzení schůzky.
            </p>
            <p>
              Pokud se přihlásíte k měsíčním radám nebo si necháte zaslat checklist,
              uchovávám váš e-mail za účelem jejich zasílání. Z měsíčních rad se můžete
              kdykoli odhlásit odpovědí na e-mail.
            </p>
            <p>
              Pokud mi pošlete hlasový vzkaz, zpracovávám nahrávku společně s vaším jménem
              a e-mailem výhradně k vyřízení vzkazu. Nahrávku smažu, jakmile ji vybavím.
            </p>
            <p>
              Pokud jste můj klient, mohu vám vytvořit osobní pojišťovací pas — neveřejný
              přehled vašich smluv dostupný pouze přes váš jedinečný odkaz. Údaje v něm
              (názvy smluv, pojišťovny, výročí) uchovávám po dobu naší spolupráce a na váš
              pokyn pas kdykoli smažu.
            </p>
            <p>
              Údaje nikomu nepředávám mimo potřebnou technickou správu webu a nepoužívám je
              k marketingovým účelům bez vašeho souhlasu.
            </p>
          </Section>

          <Section title="Jak dlouho údaje uchovávám">
            <p>
              Zprávy z formuláře uchovávám pouze po dobu nezbytnou k vyřízení dotazu
              a případné navazující spolupráci.
            </p>
          </Section>

          <Section title="Vaše práva">
            <p>
              Máte právo na přístup ke svým údajům, jejich opravu nebo výmaz, právo vznést
              námitku proti zpracování a právo podat stížnost u Úřadu pro ochranu osobních údajů.
              Stačí mi napsat na výše uvedený e-mail.
            </p>
          </Section>

          <Section title="Cookies">
            <p>
              Web používá jen technicky nezbytné cookies, bez kterých se neobejde.
              Měřicí a reklamní cookies (nástroje Googlu a Mety) spustím pouze tehdy,
              když mi k tomu dáte souhlas v liště, která se zobrazí při první návštěvě.
            </p>
            <p>
              Svůj souhlas můžete kdykoli změnit odkazem „Nastavení cookies" v patičce webu.
            </p>
          </Section>
        </div>
      </main>
      <Footer />
    </>
  );
}
